import { useTranslator } from '../translator/hook'
import './setupSlideButtonConnect.css'
// icon_connect / icon_unconnect 系の class 定義。ヘッダーの LinkageButton の有無に
// 依存せず、実際に class を使うこのコンポーネントから明示的に読み込む。
import '../buttons/smallButtonConnect.css'
import { useTooltip } from '../tooltipHook'
import { Tooltip } from '../tooltip'
import ConnectIcon from '../buttons/icons/connectIcon'
import { useBreakpoint, Breakpoint } from '../breakpoints'
import UnconnectIcon from '../buttons/icons/unconnectIcon'

type Props = {
  connected: boolean
  onClick: () => void
  tooltipLabel: string
  'aria-disabled'?: boolean
}

export const SetupSlideButtonConnect = ({
  connected,
  onClick,
  tooltipLabel,
  ...rest
}: Props) => {
  const { t } = useTranslator()
  const isWide = !useBreakpoint(Breakpoint.phase1)
  const { getReferenceProps, refs, tooltipProps } = useTooltip({
    placement: 'bottom-end',
  })
  return (
    <div
      ref={refs.setReference}
      {...getReferenceProps()}
      className={
        connected ?
          'setup-slide-connect-button'
        : 'setup-slide-unconnect-button'
      }
      {...rest}
      onClick={() => (connected ? null : onClick())}
    >
      {tooltipLabel && (
        <Tooltip {...tooltipProps} className="linkage-button-tooltip">
          {tooltipLabel}
        </Tooltip>
      )}
      {connected ?
        <ConnectIcon
          className={isWide ? 'icon_connect_wide' : 'icon_connect'}
        />
      : <UnconnectIcon
          className={isWide ? 'icon_unconnect_wide' : 'icon_unconnect'}
        />
      }

      {isWide && t(connected ? 'linked' : 'link')}
    </div>
  )
}
